import { render, staticRenderFns } from "./attendeesGrid.vue?vue&type=template&id=2a4c18c2&scoped=true&"
import script from "./attendeesGrid.vue?vue&type=script&lang=js&"
export * from "./attendeesGrid.vue?vue&type=script&lang=js&"
import style0 from "./attendeesGrid.vue?vue&type=style&index=0&id=2a4c18c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4c18c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\tavo\\source\\repos\\GEG\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2a4c18c2', component.options)
    } else {
      api.reload('2a4c18c2', component.options)
    }
    module.hot.accept("./attendeesGrid.vue?vue&type=template&id=2a4c18c2&scoped=true&", function () {
      api.rerender('2a4c18c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\attendees\\attendeesGrid.vue"
export default component.exports